import { Area, CleaningMission, CleaningMissionSortInput, Unit } from '@silbo/core';

export type CleaningMissionListItem = CleaningMissionSortInput & { mission: CleaningMission; unit?: Unit };

/** L'entrée prévue est celle que Silbo tient sur le lit ; l'unité est celle du lit. */
export const toCleaningMissionListItem = (
  mission: CleaningMission,
  unitOfBed: (bed: Area) => Unit | undefined
): CleaningMissionListItem => ({
  mission,
  unit: unitOfBed(mission.bed),
  plannedEntryAt: mission.bed.nextSlotAt,
  priority: mission.priority,
  requestedAt: mission.requestedAt,
});

export const isInUnits = (item: CleaningMissionListItem, unitIds: string[]): boolean =>
  !!item.unit && unitIds.includes(item.unit.id);
